import React, { ReactElement } from "react";
import Layout from "../../components/layout";
import ServiceLocationList from "../../components/ServiceLocation";

const ServiceLocationPage = (): ReactElement => {
  return (
    <Layout>
      <ServiceLocationList />
    </Layout>
  );
};

export default ServiceLocationPage;
